// extracted by mini-css-extract-plugin
export default {"root":"SetSuccess_root__PtDmC","title":"SetSuccess_title__5NhHi","content":"SetSuccess_content__dGQOU","actions":"SetSuccess_actions__e2Ggu"};